import {getStore} from '@/utils/'

export default{
    setMember({commit},name){//设置当前用户信息
        commit('SETMEMBER',getStore(name));
    }
}